export function createGuidSet<T extends { guid: string }>(array: T[]): Set<string> {
  return new Set(array.map((item) => item.guid));
}
